import { render, staticRenderFns } from "./TownAdmin.vue?vue&type=template&id=350a6699&scoped=true"
import script from "./TownAdmin.vue?vue&type=script&lang=js"
export * from "./TownAdmin.vue?vue&type=script&lang=js"
import style0 from "./TownAdmin.vue?vue&type=style&index=0&id=350a6699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a6699",
  null
  
)

export default component.exports